import { Button, Typography } from '@/design-system/Atoms';
import { HeroFeatureList } from '@/design-system/Molecules'; 
import { usePatientCTAButtonConfig } from "@/hooks/usePatientCTAButtonConfig";

export interface HeroContentProps {
    title: string;
    description: string;
    buttonText?: { text: string, afterUpdateProfileText: string, to: string },
    features?: { icon: string; text: string }[];
}

const HeroContent = ({ title, description, buttonText, features }: HeroContentProps) => {   
      const { ctaButtonConfig, patientEntitlementsIsLoading } =
        usePatientCTAButtonConfig(buttonText?.text);
    return (
      <div className="container relative z-10 overflow-hidden pb-[6.25rem] lg:pb-0">
        <div className="flex flex-wrap lg:flex-nowrap lg:flex-row-reverse items-start gap-y-5 lg:gap-x-5">
          {features && (
            <div className="w-full lg:w-1/2 px-4 lg:px-0">
              <HeroFeatureList features={features} />
            </div>
          )}

          <div
            className={`w-full ${features ? "lg:w-1/2" : ""} px-4 lg:px-0 pt-6 lg:pt-0`}
          >
            <Typography variant="heroBannerTitle" as="h1" className="mb-4">
              {title}
            </Typography>

            <Typography
              variant={
                features ? "heroBannerDescription" : "sectionDescriptionSmall"
              }
              as="p"
              className="mb-[3.75rem] text-white"
            >
              {description}
            </Typography>

            {buttonText && (
              <Button
                variant="secondary"
                size="xl"
                className="w-full md:w-auto mt-6" 
                onClick={ctaButtonConfig.action}
                loading={patientEntitlementsIsLoading}
              >
                {ctaButtonConfig.text}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
};

export default HeroContent;
